import React from 'react';
import TableCell from '../../ui/table/tableCell/TableCell';
import TableContainer from '../../ui/table/tableContainer/TableContainer';
import TableHead from '../../ui/table/tableHead/TableHead';
import TableRow from '../../ui/table/tableRow/TableRow';
import TableBody from '../../ui/table/tableBody/TableBody';
import Table from '../../ui/table/Table';
import BaseRow from '../BaseRow/BaseRow';
import Loader from '../../ui/loader/loader';
import { BasesTableProps } from '../../../types/base';
import styles from './basesTable.module.sass';
import { useTranslation } from 'react-i18next';

const BasesTable: React.FC<BasesTableProps> = ({
  bases,
  isAdmin,
  isLoading,
  addedToCartIds,
  onAddToCart,
  onDeleteFromCart,
  onSaveChanges,
  onDelete,
  onScroll,
}) => {
  const { t } = useTranslation();
  const handleScroll = (e: React.UIEvent<HTMLDivElement>) => {
    const { scrollTop, scrollHeight, clientHeight } = e.currentTarget;
    const scrollProgress = (scrollTop + clientHeight) / scrollHeight;

    if (onScroll) {
      onScroll(scrollProgress);
    }
  };

  return (
    <TableContainer
      style={{ height: '65vh', position: 'relative' }}
      onScroll={handleScroll}
    >
      <Table>
        <TableHead>
          <TableRow>
            <TableCell
              variant="head"
              className={`${styles.titleColumn} ${styles.headCell}`}
            >
              {t('usersBases.title')}
            </TableCell>
            <TableCell
              variant="head"
              className={`${styles.descriptionColumn} ${styles.headCell}`}
            >
              {t('usersBases.description')}
            </TableCell>
            {isAdmin && (
              <TableCell
                variant="head"
                className={`${styles.saleColumn} ${styles.headCell}`}
              >
                {t('adminBases.processed')}
              </TableCell>
            )}
            <TableCell
              variant="head"
              className={`${styles.createColumn} ${styles.headCell}`}
            >
              {t('adminBases.created')}
            </TableCell>
            <TableCell
              variant="head"
              className={`${styles.dataCountColumn} ${styles.headCell}`}
            >
              {t('adminBases.dataCount')}
            </TableCell>
            <TableCell
              variant="head"
              className={`${styles.chatsColumn} ${styles.headCell}`}
            >
              {t('adminBases.parsedChats')}
            </TableCell>
            {!isAdmin && (
              <TableCell
                variant="head"
                className={`${styles.priceColumn} ${styles.headCell}`}
              >
                {t('usersBases.cost')}
              </TableCell>
            )}
            <TableCell
              variant="head"
              className={`${styles.buttonsColumn} ${styles.headCell}`}
            >
              {t('adminBases.actions')}
            </TableCell>
          </TableRow>
        </TableHead>
        {isLoading && bases.length === 0 ? (
          <div className={styles.loaderWrapper}>
            <Loader />
          </div>
        ) : (
          <TableBody>
            {bases.map((base) => (
              <BaseRow
                key={base.id}
                base={base}
                isAdmin={isAdmin}
                isAddedToCart={addedToCartIds.includes(base.id)}
                onAddToCart={onAddToCart}
                onDeleteFromCart={onDeleteFromCart}
                onSaveChanges={onSaveChanges}
                onDelete={onDelete}
              />
            ))}
          </TableBody>
        )}
      </Table>
    </TableContainer>
  );
};

export default BasesTable;
